// extracted by mini-css-extract-plugin
export var icon = "_a6-3";
export var subtitle = "_a6-2";
export var title = "_a6-1";
export var value = "_a6-0";